import { CoveoCommerceState } from "@DSG/Store/Data/CoveoCommerceState";
import { DISPATCH_RESET_SEARCH_INPUT_QUERY, DISPATCH_UPDATE_PRODUCT_LISTING_STATE, DISPATCH_UPDATE_SEARCH_STATE } from "@DSG/Store/Reducer/CoveoCommerceReducer";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import { useRef } from "react";
import { useDispatch } from "react-redux";

const useCoveoCommerceExtras = (coveoCommerce: CoveoCommerceState) => {
    const History = useHistory();
    const searchInputRef = useRef<HTMLInputElement | null>(null);
    const dispatch = useDispatch();
    
    const resetSearchInputQuery = () => dispatch({
        type: DISPATCH_RESET_SEARCH_INPUT_QUERY
    });

    const doCoveoSearch = (query: string) => {
         coveoCommerce?.SearchBoxController?.updateText(query);
         const isSearchPage = window.location.pathname === "/search";
         if (isSearchPage) { coveoCommerce?.SearchBoxController?.submit(); }
         else {
            History.push(`/search#q=${query}`);
         }
    };

    const resetSearchStateProducts = () => {
        dispatch({
            type: DISPATCH_UPDATE_SEARCH_STATE,
            state: {
                ...coveoCommerce.SearchState,
                products: []
            }
        });
    };

    const resetProductListingProducts = () => {
        dispatch({
            type: DISPATCH_UPDATE_PRODUCT_LISTING_STATE,
            state: {
                ...coveoCommerce.ProductListingState,
                products: []
            }
        });
    };

    const clearSearchAndProductValues = () => {
        // console.log("clearSearchAndProductValues >>");
        coveoCommerce?.SearchBoxController?.clear();
        resetSearchInputQuery();
        searchInputRef.current?.blur();
        if (coveoCommerce?.SearchState?.products) { resetSearchStateProducts(); }
        if (coveoCommerce?.ProductListingState?.products) { resetProductListingProducts(); }
    };

    return {
        doCoveoSearch,
        clearSearchAndProductValues,
        searchInputRef
    };
};

export default useCoveoCommerceExtras;